import { render } from "./CoolingUnitCallConfigQuery.vue?vue&type=template&id=56e6b8b1"
import script from "./CoolingUnitCallConfigQuery.vue?vue&type=script&lang=js"
export * from "./CoolingUnitCallConfigQuery.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__